module.exports = "\u0002�RCopyright 1990-2009 Adobe Systems Incorporated.\nAll rights reserved.\nSee ./LICENSE\u0000\u0001\u0000�`\u0002 ?�F\u0000\u001e�\u0007"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/pdfjs-dist/cmaps/Katakana.bcmap
// module id = 1104
// module chunks = 55